import { X, Minus, Plus, Trash2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Link } from "react-router-dom";
import { formatINR } from "@/lib/api";

export default function CartDrawer() {
  const { cartOpen, setCartOpen, cart, updateQty, removeFromCart, cartSubtotal, settings } = useApp();

  if (!cartOpen) return null;

  return (
    <div className="fixed inset-0 z-50" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/70" onClick={() => setCartOpen(false)} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[460px] bg-[#0A0A0A] border-l border-white/10 flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-white/10">
          <div>
            <div className="overline text-white/50">Your Cart</div>
            <div className="font-display text-xl">{cart.length} {cart.length === 1 ? "ITEM" : "ITEMS"}</div>
          </div>
          <button onClick={() => setCartOpen(false)} className="p-2" data-testid="cart-drawer-close"><X size={22} /></button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {cart.length === 0 ? (
            <div className="p-8 text-center">
              <div className="overline text-white/40 mb-3">Cart is empty</div>
              <p className="text-white/60 mb-6">Add some accessories to elevate your ride.</p>
              <Link to="/shop" onClick={() => setCartOpen(false)} className="sa-btn sa-btn-primary">START SHOPPING</Link>
            </div>
          ) : (
            <ul className="divide-y divide-white/5">
              {cart.map((item) => (
                <li key={item.product_id} className="p-5 flex gap-4" data-testid={`cart-item-${item.product_id}`}>
                  <div className="w-20 h-20 bg-white/5 flex-shrink-0">
                    {item.image && <img src={item.image} alt={item.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm leading-tight mb-1">{item.name}</div>
                    <div className="text-[#E63946] font-bold text-sm mb-3">{formatINR(item.price)}</div>
                    <div className="flex items-center justify-between">
                      <div className="inline-flex items-center border border-white/15">
                        <button className="p-1.5" onClick={() => updateQty(item.product_id, item.quantity - 1)} data-testid={`cart-dec-${item.product_id}`}><Minus size={14} /></button>
                        <span className="px-3 text-sm">{item.quantity}</span>
                        <button className="p-1.5" onClick={() => updateQty(item.product_id, item.quantity + 1)} data-testid={`cart-inc-${item.product_id}`}><Plus size={14} /></button>
                      </div>
                      <button onClick={() => removeFromCart(item.product_id)} className="text-white/50 hover:text-[#E63946]" data-testid={`cart-remove-${item.product_id}`}>
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {cart.length > 0 && (
          <div className="border-t border-white/10 p-5 space-y-4">
            <div className="flex justify-between items-center">
              <span className="overline text-white/60">Subtotal</span>
              <span className="font-display text-xl">{formatINR(cartSubtotal)}</span>
            </div>
            <div className="text-xs text-white/50">
              Shipping calculated at checkout. Online payment only. Cash on Delivery is currently unavailable.
            </div>
            <div className="flex flex-col gap-3">
              <Link to="/checkout" onClick={() => setCartOpen(false)} className="sa-btn sa-btn-primary w-full" data-testid="checkout-button">CHECKOUT</Link>
              <button onClick={() => setCartOpen(false)} className="sa-btn sa-btn-outline w-full">Continue Shopping</button>
            </div>
          </div>
        )}
      </aside>
    </div>
  );
}
